export default __webpack_public_path__ + "static/media/arrow-right-disabled.780487f5.svg";